import { render, staticRenderFns } from "./componentSet.vue?vue&type=template&id=5ac679d4&"
import script from "./componentSet.vue?vue&type=script&lang=js&"
export * from "./componentSet.vue?vue&type=script&lang=js&"
import style0 from "./componentSet.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports